import assign from 'lodash/assign';
import omit from 'lodash/omit';
import queryUtils from 'app/shared/utils/queryUtils';

type QueryParams = Record<string, string | number | undefined>;

const controller = {
  makeLink(page: number, query: QueryParams, url: string): string {
    const newQuery = controller.getQuery(page, query);

    return url + queryUtils.stringify(newQuery);
  },
  getQuery(page: number, query: QueryParams): QueryParams {
    // Only use query parameter page=n if n != 1 (because ?page=1 would be default url)
    let newQuery: QueryParams;
    if (page !== 1) {
      newQuery = assign({}, query, {
        page,
      });
    } else {
      newQuery = omit(query, 'page');
    }

    return newQuery;
  },
  isEdgePage(page: number, maxPage: number): boolean {
    // checks if the page link is for prev/next buttons
    if (page - 1 === maxPage || page + 1 === 1) {
      return true;
    } else {
      return false;
    }
  },
  isInvalidPage(page: number, maxPage: number): boolean {
    return page > maxPage || page <= 0;
  },
};

export default controller;
